/** 接口正确的 code 值 */
export const SUCCESS_CODE = 0

/** 接口错误码 */
export const ERROR_CODES = {
  /** 未登录 */
  LOGIN_REQUIRED: 400003,
  /** 调用接口失败 */
  API_CALL_FAILED: 200001,
  /** 文件上传失败 */
  FILE_UPLOAD_FAILED: 100002,
  /** 参数格式错误 */
  INVALID_PARAMS_FORMAT: 100001,
} as const
